import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  previewContainer: {
    position: 'relative',
    justifyContent: 'center',
    width: 200,
    height: 120,
  },
  iconContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 100,
  },
  icon: {
    width: 32,
    height: 32,
  },
  imagePreview: {
    width: 200,
    height: 120,
    borderRadius: 12,
  },
});
